export default __webpack_public_path__ + "static/hf-1-75137a4cd9e8883ef85c7e3419a933d3.png";